import ScreenContainer from '../../display/ui/ScreenContainer';
import LoadBar from './LoadBar';
import CharacterSimple from '../../seek/CharacterSimple';

// empty group that will automatically center itself
export default class LoadDisplay extends ScreenContainer {
  constructor(game) {
    super(game, { background: 'bg_location_summer' });

    this.onAnimationComplete = new Phaser.Signal();

    // add load bar
    this.loadBar = new LoadBar(this.game);
    this.loadBar.x = this.game.defaultWidth * 0.5 - this.loadBar.width * 0.5;
    this.loadBar.y = 510;
    this.add(this.loadBar);

    // elinor
    this.elinor = new CharacterSimple(
      this.game,
      this.game.defaultWidth * 0.5,
      370,
      'elinor',
      'right'
    );
    this.elinor.playAnim('preloader');
    this.elinor.setScale(0.3);
    this.addChild(this.elinor);
  }

  setProgress(value) {
    this.loadBar.setProgress(Math.max(0, Math.min(1, value)));
  }

  setProcessing() {
    this.loadBar.setProcessing();
  }

  animateCompleteSequence() {
    this.loadBar.tweenInCrystal();
    this.animateOutTween = this.game.add
      .tween(this)
      .to({ alpha: 0 }, 200, Phaser.Easing.Quadratic.Out, true, 2000);

    this.animateOutTween.onComplete.add(this.handleAnimateSequenceComplete, this);
  }
  handleAnimateSequenceComplete() {
    this.onAnimationComplete.dispatch();
  }

  destroy() {
    this.onAnimationComplete.removeAll();
    if (this.animateOutTween) {
      this.animateOutTween.stop();
      this.game.tweens.remove(this.animateOutTween);
    }
    this.loadBar.destroy();

    this.onAnimationComplete = null;
    this.animateOutTween = null;
    this.loadBar = null;
    super.destroy(true);
  }
}
